var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D32020",
    fillRule: "evenodd",
    d: "M8.429 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12M1.095 8a7.333 7.333 0 1 1 14.667 0A7.333 7.333 0 0 1 1.095 8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D32020",
    fillRule: "evenodd",
    d: "M8.429 4.667c.368 0 .666.298.666.666V8a.667.667 0 1 1-1.333 0V5.333c0-.368.298-.667.667-.667M7.762 10.667c0-.369.298-.667.667-.667h.006a.667.667 0 1 1 0 1.333H8.43a.667.667 0 0 1-.667-.667",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;